export const constants = {
    isTouch: "ontouchstart" in window ? function () {
        document.body.classList.add("touch");
        return true;
    }() : function () {
        document.body.classList.add("no-touch");
        return false;
    }(),
    body: $("body")
};

export function scrollTo() {
    $('.scroll').on('click', function (e) {
        e.preventDefault();
        let id = $(this).attr('href');
        console.log(id);
        $('html, body').animate({
            scrollTop: $(id).offset().top - $('.header').outerHeight(),
        }, 1500);
    })
}

let headerSearch = $('.header-search');
let menu = $('.menu');
let btnMenu = $(".menu-burger");
let btnSearch = $(".btn-search.open-search");
let searchClear = headerSearch.find('.clear');

export function mobileNav() {
    let body = $('body');
    let parentElements = $("html, body");
    let mainContainer = $(".main");
    let windowWidth = window.innerWidth;
    let scrollTop;

    function lockBody() {
        if (window.pageYOffset) {
            scrollTop = window.pageYOffset;
            mainContainer.css({
                top: -(scrollTop)
            });
        }
        parentElements.css({
            height: "100%",
            overflow: "hidden"
        });
    }

    function unlockBody() {
        parentElements.css({
            height: "",
            overflow: ""
        });
        mainContainer.css({
            top: ""
        });
        window.scrollTo(0, scrollTop);
        window.setTimeout(function () {
            scrollTop = null;
        }, 0);
    }

    btnMenu.on("click", function (e) {
        let $this = $(this);
        if (!$this.hasClass("open")) {
            $this.addClass("open");
            if (windowWidth < 1200 && !(/(android)/i.test(navigator.userAgent))) {
                lockBody();
            }
        } else {
            $this.removeClass("open");
            if (windowWidth < 1200 && !(/(android)/i.test(navigator.userAgent))) {
                unlockBody();
            }
        }

        body.toggleClass("menu-open");
        btnSearch.removeClass('active');
        headerSearch.removeClass('active');
        btnMenu.removeClass('hidden');
        headerSearch.find('input').val('');
        e.preventDefault();
    });
    searchClear.on('click', function () {
        headerSearch.find('input').val('');
    });
    $('<span class="arrow"></span>').insertAfter($('.main-nav .menu-item-has-children > a'));

    $(document).on('click', '.main-nav .arrow', function () {
        $(this).parent().find('ul').slideToggle();
    });

    $(document).on("click", function (e) {
        if (window.innerWidth >= 1200) {
            let $target = $(e.target);
            if (!$target.closest(".header").length && !$target.closest(btnMenu).length && menu.hasClass("active")) {
                $(".open-search, .header-search, .menu").removeClass("active");
                btnMenu.removeClass("hidden");
            }
        }
    });
}

export function searchToggle() {
    btnSearch.on("click", function (e) {
        $(this).toggleClass('active');
        headerSearch.find('input').val('');
        setTimeout(() => {
            headerSearch.find('input').focus();
        }, 300);
        headerSearch.toggleClass("active");
        $('.menu').toggleClass('active');
        btnMenu.toggleClass('hidden');
        e.preventDefault();
    });
}

export function headerTheme() {
    if ($('body').hasClass('no-touch')) {
        let $header = $(".header.home");
        let top = window.pageYOffset;
        top = (top < 0) ? 0 : window.pageYOffset;

        if (top > 0) {
            $header.removeClass("transparent");
        } else {
            $header.addClass("transparent");
        }
    }
}

window.addEventListener("scroll", () => {
    headerTheme();
});


// WEBPACK FOOTER //
// ./assets/js/modules/module.js